module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-left-bendy-arrow-teal-ea2fb76e3b01a25686e0362e7ae4fcf7.svg";